import React from 'react'

export default function AccountError() {
    return(
        <>
            <p>System is currently unavailable. Please try again later.</p>
        </>
    )
}